module.exports = __webpack_public_path__ + "img/setUp.04a8df98.png";